import { useRuntimeConfig, defineNuxtPlugin, ref } from "#imports";
import posthog from "posthog-js";

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const posthogKey = config.public.posthogPublicKey;
  const posthogHost = config.public.posthogHost;

  const posthogClient = posthog.init(posthogKey, {
    api_host: posthogHost,
    person_profiles: "always",
    debug: false,
    capture_pageview: true,
    persistence: "cookie",
    cookie_expiration: 0,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: "*",
      maskTextFn(text) {
        // A simple email regex - you may want to use something more advanced
        const emailRegex = /(\S+)@(\S+\.\S+)/g;
        // deno-lint-ignore no-unused-vars
        return text.trim().replace(emailRegex, (_match, g1, g2) => {
          // Replace each email with asterisks - ben@posthog.com becomes ***@***********
          return `${"*".repeat(g1.length)}@${"*".repeat(g2.length)}`;
        });
      },
    },
  });

  const posthogIdentifier = ref<string>(posthogClient.get_distinct_id());

  return {
    provide: {
      posthogClient,
      posthogIdentifier,
    },
  };
});
